{
  "id": "sekhmet",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Sekhmet",
    "en": "Sekhmet"
  },
  "icon": "gods/sekhmet",
  "portrait": "gods/sekhmet-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "scarab": 1
  },
  "unlocks": ["scarab", "crimson-linen", "force-of-the-west-wind", "bone-bow", "slings-of-the-sun"],
  "powers": ["citadel"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Goddess of warfare and the desert. Focus: ranged weapons and siege weapons. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 120 s."
  }
}
